const clauseCardDesc = [
  {
    type: "description",
    category: [`residential`, `fsbo`, `mere`],
    title: "Common Conditions/Clauses",
    text: `<p>
    The majority of clauses can be found within the
    <a
      href="https://www.orea.com/standard-forms-clauses"
      target="_blank"
      rel="noopener noreferrer"
    >
      OREA Clause Booklet</a>. Review the booklet to become familiar with the clauses available to
    you. The Shortcodes (example: MORT-4) are how you locate the clauses
    within the OREA Clause Booklet or your Forms Platform. The OREA
    Clause Booklet contains alternate versions of some of the clauses listed
    below, which may better suit your client's needs.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer.
  </p>`,
  },
  {
    type: "description",
    category: `assign`,
    title: "Common Conditions/Clauses",
    text: `<p>
    Since assignments involve the purchasing of an Agreement of Purchase & Sale, 
    it is important to review the Original Contract to understand the terms & 
    conditions relating to the agreement that is for sale. Advise your client to 
    choose a lawyer well-versed in assignments, as these deals tend to be more 
    complex compared to other transaction types. Refer to the <a
    href="https://www.orea.com/standard-forms-clauses"
    target="_blank"
    rel="noopener noreferrer"
  >
    OREA Clause Booklet</a> for additional clauses that may apply.<br/>
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer. 
  </p>`,
  },
  {
    type: "description",
    category: `precon`,
    title: "Common Conditions/Clauses",
    text: `<p>
    In pre-construction purchases, the majority of agreements will use the 
    Builder's Forms. It is essential to thoroughly read and understand the terms 
    of the agreement, particularly the clauses.
    <br /><br/>
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer.<br/><br/>
    <p>Important key elements to look out for: </p>
    <ol>
    <li>Lawyer Review Clause</li>
    <li>Financing Clause</li>
    <li>Deposit Structure</li>
    <li>Restrictions Relating to Assignments & Leasing</li>
    <li>Warranty Coverage</li>
    <li>Occupancy & Construction Delay Related Clauses</li>
    <li>Parking & Storage Assignments</li>
    <li>Condo Bylaws, Rules & Fees (if applicable)</li>
    <li>Developers right to change design, common areas...etc.</li>
    <li>Termination of Agreement Clauses</li>
    <li>Adjustments on Closing</li>
    </ol>
  </p>`,
  },
  {
    type: "description",
    category: [`lease`, `landlordSRP`, `leaseMere`],
    title: "Common Conditions/Clauses",
    text: `<p>
    The majority of clauses can be found within the
    <a
      href="https://www.orea.com/standard-forms-clauses"
      target="_blank"
      rel="noopener noreferrer"
    >
      OREA Clause Booklet</a>. Review the booklet to become familiar with the clauses available to
    you. The Shortcodes (example: LEASE/RES-1) are how you locate the clauses
    within the OREA Clause Booklet or your Forms Platform. 
    <br/><br/>In order to serve your client's best interests, you should be familiar 
    with the <a
    href="https://www.ontario.ca/laws/statute/06r17"
    target="_blank"
    rel="noopener noreferrer"
  >Residential Tenancies Act (RTA)</a>. Illegal clauses, meaning 
    those that contravene the RTA, should not be included in 
    the agreement. Any clause in a lease agreement that contradicts the RTA is void.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer. 
  </p>`,
  },
  {
    type: "description",
    category: [`resListing`],
    title: "Common Schedule A Clauses",
    text: `<p>
    Schedule A in the Listing Agreement is used to include any additional 
    agreed upon terms or services that aren't addressed in the standard form. 
    According to RECO, services should be clearly documented, in a comprehensible 
    manner, in the agreement, or in a Schedule to the agreement. This 
    added level of transparency is to ensure that both parties are 
    aware of the services that are being provided and to avoid any 
    misunderstandings. 
    <br/><br/>
    Schedule A is a great place to showcase to your clients 
    all the amazing services that you will provide to them. This 
    added level of professionalism will set you apart from other agents 
    and will show your clients that you are committed to providing a 
    high level of service. 
    <br/><br/>
    <strong>Important:</strong> Remember, this is a legally binding 
    contract, so it is essential to only offer services that you are 
    both capable of delivering and willing to follow through on. Follow 
    the "underpromise, overdeliver" approach.
  </p>`,
  },
];

export default clauseCardDesc;
